var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableConfigIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.625,
    height: 21.625,
    viewBox: "0 0 21.625 21.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42249",
    "data-name": "Caminho 42249",
    d: "M4.688-21.562V-.937H25.313V-21.562Zm1.875,1.875H11.25V-15H6.563Zm6.563,0h3.75V-15h-3.75Zm5.625,0h4.688V-15H18.75ZM6.563-13.125H11.25v3.75H6.563Zm6.563,0h3.75v3.75h-3.75Zm5.625,0h4.688v3.75H18.75ZM6.563-7.5H11.25v4.688H6.563Zm6.563,0h3.75v4.688h-3.75Zm5.625,0h4.688v4.688H18.75Z",
    transform: "translate(-4.188 22.063)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableConfigIcn);
export default __webpack_public_path__ + "static/media/table_config_icn.090a9d9b9a3afcbc0f49c481a5279bc3.svg";
export { ForwardRef as ReactComponent };